import React, { useEffect, useState } from "react";
import { styleScreenDashboard } from "../styles/style";
import "../styles/style.css";
import ModalOrderDetails from "../components/modals/modalOrderDetails";
import RowItem from "../components/transitOrders/row";
import useListOrders from "../hooks/useListOrders";
import ColumOptions from "../components/columnOptions/columnOptions";
const headers = [
  {
    title: "ID",
    tooltip: "ID de la orden",
  },
  {
    title: "Última actualización",
    tooltip: "Fecha y hora en la que fue actualizada por última vez la orden",
  },
  {
    title: "Tipo",
    tooltip: "Tipo de orden",
  },
  {
    title: "Cliente",
    tooltip: "Nombre del cliente",
  },
  {
    title: "Tienda",
    tooltip: "Nombre de la tienda",
  },
  {
    title: "Estatus actual",
    tooltip: "Estatus en el que se encuentra la orden",
  },
  {
    title: "Ver más",
    tooltip: "Consultar más detalles de la orden",
  },
];

const Orders = ({ messageAssignOrder, optionSideBarSelected }) => {
  const { getAllOrdersbyDate, allOrders } = useListOrders();

  const [dataOrders, setDataOrders] = useState([]);
  const [show, setShow] = useState(false);
  const [orderSelected, setOrderSelected] = useState({});

  useEffect(() => {
    (async () => {
      await getAllOrders();
    })();
    return () => {};
  }, []);

  /**
   * Return the list of current orders
   */
  const getAllOrders = async () => {
    getAllOrdersbyDate()
      .then(() => {
        if (!!allOrders) {
          setDataOrders(allOrders);
        }
      })
      .catch((error) => {
        console.log("error [getAllOrders] ", error);
      });
  };

  //? states to control the modal
  const handleClose = () => {
    setShow(false);
    setOrderSelected({});
  };
  const handleShow = () => setShow(true);

  //? selected order to see the details
  const selectOrder = (order) => {
    setOrderSelected(order);
    handleShow();
  };
  return (
    <div className="row">
      <div className="col-10">
        <h1 style={{ textAlign: "center" }}>Ordenes en proceso</h1>
        <div className="container" style={styleScreenDashboard.containerColumn}>
          <div>
            {orderSelected != {} && show && (
              <ModalOrderDetails
                orderInfo={orderSelected}
                show={show}
                handleClose={handleClose}
              />
            )}

            {dataOrders.length > 0 ? (
              <div
                className="container"
                style={styleScreenDashboard.containerColumn}
              >
                <table className="table table-sm table-hover table-responsive">
                  <thead className="thead-dark">
                    <tr>
                      {headers.map((item, x) => (
                        <th scope="col" className="text-center" key={x + "btn"}>
                          <button
                            type="button"
                            className="btn"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item.tooltip}
                          >
                            {item.title}
                          </button>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {dataOrders?.map((item, index) => (
                      <RowItem
                        key={item.id}
                        hour={item.updatedAt}
                        idOrder={item.id}
                        order={item}
                        messageAssignOrder={messageAssignOrder}
                        selectOrder={selectOrder}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div>
                <h2>Vaya ... no hay ordenes en transcurso</h2>
              </div>
            )}
          </div>
        </div>
      </div>
      <ColumOptions onSelectOption={optionSideBarSelected} />
    </div>
  );
};

export default Orders;
